export const getErrorMessages = (error) => {
  const ERROR_MSG = {
    starts_at: `Start date can be select only current date or future.`,
    ends_at: `Please, select end date after the start date.`,
  }
  const data = Object.keys(error.response.data)

  return ERROR_MSG[data[0]]
}
